<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Loader from "@/router/views_mobagile/components/loader.vue";
import api from "@/axios";
import moment from "moment/moment";
import Swal from "sweetalert2";
import { getBaseUrl } from "@/helpers/baseUrl";
import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel,
  DxGrouping,
  DxFilterRow,
  DxPager,
  DxRemoteOperations,
} from "devextreme-vue/data-grid";
import CustomStore from "devextreme/data/custom_store";

export default {
  components: {
    Layout,
    PageHeader,
    Loader,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxStateStoring,
    DxGroupPanel,
    DxGrouping,
    DxFilterRow,
    DxPager,
    DxRemoteOperations,
  },

  data() {
    return {
      title: "Romaneios",
      items: [
        { text: "Coletor", href: "/coletor" },
        { text: "Romaneios", active: true },
      ],

      tamanhoTela: 0,
      updating: false,

      // Filtros
      filtroStatus: "",
      filtroDtIni: "",
      filtroDtFim: "",
      showModalPeriodo: false,
      submittedPeriodo: false,

      // Lista mobile
      romaneiosMobile: [],
      paginaAtual: 1,
      pageSize: 20,
      totalPages: 1,
      totalRegistros: 0,

      // Empresa do usuário logado
      empresaId: null,

      // Status options
      statusOpcoes: [
        { value: "", label: "Todos" },
        { value: "EL", label: "Elaboração" },
        { value: "EQ", label: "Embarque" },
        { value: "FN", label: "Finalizado" },
        { value: "CA", label: "Cancelado" },
      ],

      // DevExtreme (desktop)
      dataSourceRomaneios: null,

      dtIniFiltroDesktop: null,
      dtFimFiltroDesktop: null,
      showModalPeriodoDesktop: false,
      submittedPeriodoDesktop: false,
    };
  },

  mounted() {
    this.tamanhoTela = window.innerWidth;

    // Carregar empresa do usuário logado
    try {
      const userLogged = JSON.parse(localStorage.getItem("user"));
      this.empresaId = userLogged?.empreatu || null;
    } catch (e) {
      this.empresaId = null;
    }

    // Inicializar filtros de data com período padrão (últimos 7 dias)
    this.filtroDtIni = moment().subtract(7, "days").format("YYYY-MM-DD");
    this.filtroDtFim = moment().format("YYYY-MM-DD");

    if (this.tamanhoTela <= 500) {
      this.carregarRomaneiosMobile();
    } else {
      this.atualizaDataListDesktop();
    }
  },

  methods: {
    // ─────────────────────────────────────────────
    // MOBILE
    // ─────────────────────────────────────────────

    carregarRomaneiosMobile() {
      this.updating = true;
      const params = {
        empresa: this.empresaId,
        page: this.paginaAtual,
        pageSize: this.pageSize,
      };
      if (this.filtroStatus) params.status = this.filtroStatus;
      if (this.filtroDtIni) params.di = this.filtroDtIni;
      if (this.filtroDtFim) params.df = this.filtroDtFim;

      api
        .get(`${getBaseUrl()}api/wmsromaneios`, { params })
        .then((res) => {
          // API retorna [data[], totalCount] conforme CustomStore do desktop
          const data = Array.isArray(res.data) ? res.data[0] : res.data?.data || [];
          const total = Array.isArray(res.data) ? res.data[1] : res.data?.total || 0;
          this.romaneiosMobile = data;
          this.totalRegistros = total;
          this.totalPages = Math.max(1, Math.ceil(total / this.pageSize));
        })
        .catch((err) => {
          console.error("Erro ao carregar romaneios:", err);
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "Erro ao carregar romaneios",
            showConfirmButton: false,
            timer: 2000,
          });
        })
        .finally(() => {
          this.updating = false;
        });
    },

    mudouFiltroStatus() {
      this.paginaAtual = 1;
      this.carregarRomaneiosMobile();
    },

    aplicarPeriodo() {
      this.submittedPeriodo = true;
      if (!this.filtroDtIni || !this.filtroDtFim) return;
      this.showModalPeriodo = false;
      this.submittedPeriodo = false;
      this.paginaAtual = 1;
      this.carregarRomaneiosMobile();
    },

    paginaAnterior() {
      if (this.paginaAtual > 1) {
        this.paginaAtual--;
        this.carregarRomaneiosMobile();
      }
    },

    proximaPagina() {
      if (this.paginaAtual < this.totalPages) {
        this.paginaAtual++;
        this.carregarRomaneiosMobile();
      }
    },

    abrirRomaneio(item) {
      this.$router.push(`/coletor/romaneiocoletor/${item.id}`);
    },

    criarNovoRomaneio() {
      if (!this.empresaId) {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Empresa não identificada",
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }
      this.updating = true;
      api
        .post(`${getBaseUrl()}api/wmsromaneio`, { empresa: this.empresaId })
        .then((resp) => {
          const id = resp.data?.id || resp.data?.data?.id;
          if (!id) {
            throw new Error("ID não retornado");
          }
          this.$router.push(`/coletor/romaneiocoletor/${id}`);
        })
        .catch((err) => {
          console.error("Erro ao criar romaneio:", err);
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "Erro ao criar romaneio",
            showConfirmButton: false,
            timer: 2000,
          });
          this.updating = false;
        });
    },

    formatDate(value) {
      if (!value) return "...";
      return moment(value).format("DD/MM/YYYY");
    },

    badgeClass(status) {
      return `badge-${status}`;
    },

    formatDateTime(value) {
      if (!value) return "";
      return moment(value).format("DD/MM/YY HH:mm");
    },

    formatDecimal(value) {
      if (value === null || value === undefined) return "0,00";
      const n = parseFloat(value);
      return n.toLocaleString("pt-BR", {
        style: "decimal",
        minimumFractionDigits: 2,
      });
    },

    labelPeriodo() {
      if (this.filtroDtIni && this.filtroDtFim) {
        return (
          moment(this.filtroDtIni).format("DD/MM") +
          " - " +
          moment(this.filtroDtFim).format("DD/MM")
        );
      }
      return "Período";
    },

    // ─────────────────────────────────────────────
    // DESKTOP
    // ─────────────────────────────────────────────

    atualizaDataListDesktop() {
      const filtros = JSON.parse(localStorage.getItem("filtros"));

      if (!filtros) {
        this.dtIniFiltroDesktop = moment().subtract(1, "days").format("YYYY-MM-DD");
        this.dtFimFiltroDesktop = moment().format("YYYY-MM-DD");
        localStorage.setItem(
          "filtros",
          JSON.stringify({
            movdi: this.dtIniFiltroDesktop,
            movdf: this.dtFimFiltroDesktop,
          })
        );
      } else {
        this.dtIniFiltroDesktop = filtros["movdi"] || moment().subtract(1, "days").format("YYYY-MM-DD");
        this.dtFimFiltroDesktop = filtros["movdf"] || moment().format("YYYY-MM-DD");
      }

      const di = this.dtIniFiltroDesktop;
      const df = this.dtFimFiltroDesktop;
      const empresa = this.empresaId;
      const status = this.filtroStatus;

      this.dataSourceRomaneios = new CustomStore({
        key: "id",
        load: function (loadOptions) {
          let queryArray = [];
          if (loadOptions["filter"]) {
            if (
              loadOptions["filter"][1] === "and" ||
              loadOptions["filter"][1] === "or"
            ) {
              loadOptions["filter"].forEach((value) => {
                if (typeof value === "object") {
                  queryArray.push({ cmp: value[0], opr: value[1], val: value[2] });
                }
              });
            } else {
              queryArray.push({
                cmp: loadOptions["filter"][0],
                opr: loadOptions["filter"][1],
                val: loadOptions["filter"][2],
              });
            }
          }

          const paramsReq = {
            skip: loadOptions["skip"],
            take: loadOptions["take"],
            filter: queryArray,
            sort: loadOptions["sort"],
            di,
            df,
            empresa,
          };
          if (status) paramsReq.status = status;

          return api
            .get(`${getBaseUrl()}api/wmsromaneios`, { params: paramsReq })
            .then((response) => {
              return {
                data: response.data[0],
                totalCount: response.data[1],
              };
            });
        },
      });
    },

    criarNovoRomaneioDesktop() {
      if (!this.empresaId) {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Empresa não identificada",
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }
      this.updating = true;
      api
        .post(`${getBaseUrl()}api/wmsromaneio`, { empresa: this.empresaId })
        .then((resp) => {
          const id = resp.data?.id || resp.data?.data?.id;
          if (!id) throw new Error("ID não retornado");
          this.$router.push(`/coletor/romaneiocoletor/${id}`);
        })
        .catch((err) => {
          console.error("Erro ao criar romaneio:", err);
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "Erro ao criar romaneio",
            showConfirmButton: false,
            timer: 2000,
          });
        })
        .finally(() => {
          this.updating = false;
        });
    },

    onRowDblClick(e) {
      this.$router.push(`/coletor/romaneiocoletor/${e.data.id}`);
    },

    confirmarPeriodoDesktop() {
      this.submittedPeriodoDesktop = true;
      if (!this.dtIniFiltroDesktop || !this.dtFimFiltroDesktop) return;
      localStorage.setItem(
        "filtros",
        JSON.stringify({
          movdi: moment(this.dtIniFiltroDesktop).format("YYYY-MM-DD"),
          movdf: moment(this.dtFimFiltroDesktop).format("YYYY-MM-DD"),
        })
      );
      this.showModalPeriodoDesktop = false;
      this.submittedPeriodoDesktop = false;
      this.atualizaDataListDesktop();
    },

    carregouGridDesktop(e) {
      const dtIniFormated = moment(this.dtIniFiltroDesktop).format("DD/MM/YYYY");
      const dtFimFormated = moment(this.dtFimFiltroDesktop).format("DD/MM/YYYY");
      this.title = `(${e.component.totalCount()}) Romaneios: ${dtIniFormated} - ${dtFimFormated}`;
    },

    onCellPrepared(e) {
      if (e.rowType === "data" && e.column.dataField === "status") {
        const valStatus = e.data.status;
        let corStatus = "rgba(78,59,0,0.5)";
        switch (valStatus) {
          case "EL": corStatus = "rgba(78,59,0,0.5)"; break;
          case "CA": corStatus = "rgba(146,20,0,0.5)"; break;
          case "FN": corStatus = "rgba(33,78,0,0.5)"; break;
          case "EQ": corStatus = "rgba(0,58,78,0.5)"; break;
          case "SE": corStatus = "rgba(33,78,0,0.5)"; break;
        }
        e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
      }
    },

    nomeStatus(e) {
      switch (e.value) {
        case "SE": return "Conferido (SE)";
        case "FN": return "Finalizado (FN)";
        case "EL": return "Elaboração (EL)";
        case "CA": return "Cancelado (CA)";
        case "EQ": return "Embarque (EQ)";
      }
      return e.value;
    },

    limparFiltrosDesktop() {
      if (this.$refs.dataGridRefKey) {
        this.$refs.dataGridRefKey.instance.state(null);
      }
    },
  },
};
</script>

<template>
  <!-- ═══════════════════════════════════════════════════
       DESKTOP (> 500px)
  ════════════════════════════════════════════════════ -->
  <Layout v-if="tamanhoTela > 500">
    <PageHeader :title="title" :items="items" />

    <div class="mb-2 d-flex gap-2 align-items-center flex-wrap">
      <button class="btn btn-success btn-sm" @click="criarNovoRomaneioDesktop">
        + Criar Novo Romaneio
      </button>
      <button class="btn btn-outline-secondary btn-sm" @click="showModalPeriodoDesktop = true">
        Período: {{ formatDate(dtIniFiltroDesktop) }} → {{ formatDate(dtFimFiltroDesktop) }}
      </button>
      <select
        v-model="filtroStatus"
        class="form-select form-select-sm"
        style="width: auto; min-width: 140px;"
        @change="atualizaDataListDesktop"
      >
        <option v-for="s in statusOpcoes" :key="s.value" :value="s.value">{{ s.label }}</option>
      </select>
      <button class="btn btn-outline-secondary btn-sm" @click="limparFiltrosDesktop">
        Limpar filtros
      </button>
    </div>

    <Loader v-if="updating" style="min-height: 300px;" />

    <div class="mt-2" v-if="!updating && dataSourceRomaneios">
      <DxDataGrid
        ref="dataGridRefKey"
        :data-source="dataSourceRomaneios"
        :show-borders="true"
        :focused-row-enabled="true"
        :column-auto-width="true"
        :show-row-lines="true"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :row-alternation-enabled="true"
        @cell-prepared="onCellPrepared"
        @row-dbl-click="onRowDblClick"
        @content-ready="carregouGridDesktop"
      >
        <DxRemoteOperations
          :filtering="true"
          :paging="true"
          :sorting="true"
          :summary="true"
          :grouping="false"
          :group-paging="false"
        />

        <DxColumnChooser :enabled="true" />
        <DxColumnFixing :enabled="true" />
        <DxFilterRow :visible="true" />
        <DxSelection mode="multiple" />
        <DxExport :enabled="true" :allow-export-selected-data="true" />
        <DxStateStoring
          :enabled="true"
          type="sessionStorage"
          storage-key="strRomaneioColetorList"
        />
        <DxGroupPanel :visible="true" />
        <DxGrouping />

        <DxColumn
          sort-order="desc"
          data-field="id"
          caption="ID"
          alignment="right"
          :allow-sorting="true"
          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
          :allow-header-filtering="true"
        />
        <DxColumn
          data-field="created_at"
          caption="Criado Em"
          alignment="center"
          data-type="datetime"
          format="dd/MM/yyyy"
          :allow-sorting="true"
          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
          :allow-header-filtering="true"
        />
        <DxColumn
          data-field="status"
          caption="Status"
          alignment="left"
          data-type="string"
          :allow-sorting="true"
          :customize-text="nomeStatus"
          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
          :allow-header-filtering="true"
        />
        <DxColumn
          data-field="nometransp"
          caption="Transportadora"
          alignment="left"
          data-type="string"
          :allow-sorting="false"
          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
          :allow-header-filtering="true"
        />
        <DxColumn
          data-field="motorista"
          caption="Motorista"
          alignment="left"
          data-type="string"
          :allow-sorting="false"
          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
          :allow-header-filtering="true"
        />
        <DxColumn
          data-field="contos"
          caption="Notas"
          alignment="right"
          data-type="number"
          :allow-sorting="false"
          :allow-header-filtering="false"
        />
        <DxColumn
          data-field="contvols"
          caption="Volumes"
          alignment="right"
          data-type="number"
          :allow-sorting="false"
          :allow-header-filtering="false"
        />
        <DxColumn
          data-field="somapeso"
          caption="Peso Total"
          alignment="right"
          data-type="text"
          :allow-sorting="false"
          :allow-header-filtering="false"
        />
        <DxColumn
          data-field="totalitens"
          caption="Total Itens"
          alignment="right"
          data-type="number"
          :allow-sorting="false"
          :allow-header-filtering="false"
        />
        <DxColumn
          data-field="conferido"
          caption="Conferidos"
          alignment="right"
          data-type="number"
          :allow-sorting="false"
          :allow-header-filtering="false"
        />
        <DxColumn
          data-field="pendente"
          caption="Pendentes"
          alignment="right"
          data-type="number"
          :allow-sorting="false"
          :allow-header-filtering="false"
        />

        <DxPager
          :visible="true"
          :show-page-size-selector="true"
          :allowed-page-sizes="[10, 30, 50, 100]"
          :show-navigation-buttons="true"
          :show-info="true"
        />
      </DxDataGrid>
    </div>

    <!-- Modal Período Desktop -->
    <b-modal
      title="Período de Exibição"
      v-model="showModalPeriodoDesktop"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="mb-3">
            <label for="dtIniDesktop">Data Início</label>
            <input
              id="dtIniDesktop"
              v-model="dtIniFiltroDesktop"
              type="date"
              class="form-control"
              :class="{ 'is-invalid': submittedPeriodoDesktop && !dtIniFiltroDesktop }"
            />
            <div v-if="submittedPeriodoDesktop && !dtIniFiltroDesktop" class="invalid-feedback">
              Data início é obrigatória
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="mb-3">
            <label for="dtFimDesktop">Data Fim</label>
            <input
              id="dtFimDesktop"
              v-model="dtFimFiltroDesktop"
              type="date"
              class="form-control"
              :class="{ 'is-invalid': submittedPeriodoDesktop && !dtFimFiltroDesktop }"
            />
            <div v-if="submittedPeriodoDesktop && !dtFimFiltroDesktop" class="invalid-feedback">
              Data fim é obrigatória
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-2 mt-2">
        <button class="btn btn-secondary" @click="showModalPeriodoDesktop = false">Cancelar</button>
        <button class="btn btn-primary" @click="confirmarPeriodoDesktop">Aplicar</button>
      </div>
    </b-modal>
  </Layout>

  <!-- ═══════════════════════════════════════════════════
       MOBILE (≤ 500px)
  ════════════════════════════════════════════════════ -->
  <div v-if="tamanhoTela <= 500" class="full-height-wrapper">
    <div class="card full-height-card">
      <div class="card-body full-height-body">

        <!-- Header -->
        <div class="list-header">
          <button class="btn-back-header" @click="$router.push('/dashboard/coletor')">&#8592;</button>
          <h6>Romaneios</h6>
          <button class="btn-novo" @click="criarNovoRomaneio" :disabled="updating">
            + Novo
          </button>
        </div>

        <!-- Barra de filtros -->
        <div class="filter-bar">
          <select
            v-model="filtroStatus"
            @change="mudouFiltroStatus"
          >
            <option v-for="s in statusOpcoes" :key="s.value" :value="s.value">
              {{ s.label }}
            </option>
          </select>
          <button class="btn-periodo" @click="showModalPeriodo = true">
            {{ labelPeriodo() }}
          </button>
        </div>

        <!-- Loader -->
        <div v-if="updating" class="d-flex justify-content-center align-items-center" style="flex:1;">
          <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
          <span class="ms-2" style="font-size:12px;color:#888;">Carregando...</span>
        </div>

        <!-- Lista de cards -->
        <div v-if="!updating" class="cards-list">
          <div v-if="romaneiosMobile.length === 0" class="text-center" style="padding: 30px 0; color: #aaa; font-size: 13px;">
            Nenhum romaneio encontrado
          </div>
          <div
            v-for="item in romaneiosMobile"
            :key="item.id"
            class="romaneio-card"
            @click="abrirRomaneio(item)"
          >
            <div class="card-header-row">
              <span class="romaneio-id">#{{ item.id }}</span>
              <span :class="badgeClass(item.status)">{{ item.status }}</span>
              <span class="romaneio-data">{{ formatDateTime(item.created_at) }}</span>
            </div>
            <div class="card-transp">
              {{ item.nometransp || item.transportadora?.nome || 'Sem transportadora' }}
            </div>
            <div class="card-stats">
              {{ item.contos || 0 }} docs
              · {{ formatDecimal(item.somapeso) }}kg
              · {{ item.totalitens || 0 }} itens
            </div>
          </div>
        </div>

        <!-- Paginação -->
        <div v-if="!updating" class="pagination-bar">
          <button
            class="btn-page"
            :disabled="paginaAtual <= 1"
            @click="paginaAnterior"
          >
            &laquo; Anterior
          </button>
          <span>{{ paginaAtual }} / {{ totalPages }}</span>
          <button
            class="btn-page"
            :disabled="paginaAtual >= totalPages"
            @click="proximaPagina"
          >
            Próximo &raquo;
          </button>
        </div>

      </div>
    </div>

    <!-- Modal Período Mobile -->
    <b-modal
      title="Filtrar Período"
      v-model="showModalPeriodo"
      centered
      hide-footer
    >
      <div class="mb-3">
        <label style="font-size:13px; font-weight:600;">Data Início</label>
        <input
          v-model="filtroDtIni"
          type="date"
          class="form-control form-control-sm"
          :class="{ 'is-invalid': submittedPeriodo && !filtroDtIni }"
        />
        <div v-if="submittedPeriodo && !filtroDtIni" class="invalid-feedback">
          Data início é obrigatória
        </div>
      </div>
      <div class="mb-3">
        <label style="font-size:13px; font-weight:600;">Data Fim</label>
        <input
          v-model="filtroDtFim"
          type="date"
          class="form-control form-control-sm"
          :class="{ 'is-invalid': submittedPeriodo && !filtroDtFim }"
        />
        <div v-if="submittedPeriodo && !filtroDtFim" class="invalid-feedback">
          Data fim é obrigatória
        </div>
      </div>
      <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-sm btn-secondary" @click="showModalPeriodo = false">Cancelar</button>
        <button class="btn btn-sm btn-primary" @click="aplicarPeriodo">Aplicar</button>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
/* ─── MOBILE FULL-HEIGHT LAYOUT ─── */
.full-height-wrapper {
  height: 100vh;
  overflow: hidden;
  padding: 0;
}
.full-height-card {
  height: 100%;
  margin: 0;
  border-radius: 0;
}
.full-height-body {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 8px;
}

/* ─── HEADER ─── */
.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  margin-bottom: 8px;
}
.list-header h6 {
  margin: 0;
  font-weight: 700;
  font-size: 14px;
}
.btn-back-header {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #6c757d;
  padding: 0 4px;
}

/* ─── FILTER BAR ─── */
.filter-bar {
  display: flex;
  gap: 6px;
  margin-bottom: 8px;
}
.filter-bar select {
  flex: 1;
  height: 30px;
  font-size: 12px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 0 6px;
}
.btn-periodo {
  height: 30px;
  padding: 0 10px;
  font-size: 11px;
  border: 1px solid #ddd;
  border-radius: 3px;
  background: white;
  white-space: nowrap;
  cursor: pointer;
}

/* ─── CARDS LIST ─── */
.cards-list {
  flex: 1;
  overflow-y: auto;
}
.romaneio-card {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 8px;
  cursor: pointer;
  background: white;
}
.romaneio-card:active {
  background: #f5f5f5;
}
.card-header-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.romaneio-id {
  font-weight: 700;
  font-size: 13px;
}
.romaneio-data {
  font-size: 11px;
  color: #888;
  margin-left: auto;
}
.card-transp {
  font-size: 12px;
  color: #555;
  margin-bottom: 2px;
}
.card-stats {
  font-size: 11px;
  color: #888;
}

/* ─── BADGES ─── */
.badge-EL {
  background: #17a2b8;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 3px;
}
.badge-EQ {
  background: #007bff;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 3px;
}
.badge-FN {
  background: #28a745;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 3px;
}
.badge-CA {
  background: #dc3545;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 3px;
}
.badge-SE {
  background: #6c757d;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 3px;
}

/* ─── PAGINATION ─── */
.pagination-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0 0;
  border-top: 1px solid #eee;
  margin-top: 4px;
}
.pagination-bar span {
  font-size: 11px;
  color: #888;
}
.btn-page {
  height: 28px;
  padding: 0 12px;
  font-size: 11px;
  border: 1px solid #ddd;
  border-radius: 3px;
  background: white;
  cursor: pointer;
}
.btn-page:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ─── NOVO BUTTON ─── */
.btn-novo {
  height: 28px;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 600;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}
.btn-novo:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
